import React from "react";
import { Link, useLocation } from "react-router-dom";
import LogoPic from "images/logo.png";

export interface LogoProps {
  img?: any;
  imgLight?: string;
  className?: string;
  width?: number;
}

const Logo: React.FC<LogoProps> = ({ width }) => {
  return (
    <Link
      to="https://dfwluxauto.com/"
      className={`ttnc-logo inline-block text-primary-6000 my-4 lg:my-0 focus:outline-none focus:ring-0`}
    >
      {/* <LogoSvgLight /> */}
      {/* <img width={width ? width : 120} height={60} src={LogoPic} alt="logo" /> */}

      <img
        className={`w-28 sm:w-[${
          width ?? 150
        }px] h-[50px] md:h-[100px] object-contain`}
        // style={{ width: width ? `${width}px` : undefined }}
        // height={60}
        src={LogoPic}
        alt="logo"
      />
      {/* THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {/* {img ? (
        <img
          className={`block max-h-12 ${imgLight ? "dark:hidden" : ""}`}
          src={img}
          alt="Logo"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className="hidden max-h-12 dark:block"
          src={imgLight}
          alt="Logo-Light"
        />
      )} */}
    </Link>
  );
};

export default Logo;
